
export class Report {
	public name: string;
	public reportType: number;
	public reportName: string;
	public parameters: ReportParameter[];
}

export class ReportParameter {
	public name: string;
	public key: string;
	public type: string;
	public value?: any;
	public required?: boolean;
	public options?: Array<{label: string, value: any}>;
	public api?: {method: string, text: string, value: string};
}

export class ReportData {
	public reportType: number;
	public employerID: string;
	public beginDate: Date;
	public endDate: Date;
	public campaignID?: string;

	constructor(o?: any) {
		Object.assign(this, o);
	}
}

export const ReportDefinitions = [
	{
		name: 'Employer Sessions',
		reportType: 1,
		reportName: 'Employer_Sessions',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
			{ name: 'Employer', type: 'select', key: 'employerID', required: false, api: { method: 'getEmployers', text: 'employerName', value: 'employerID' } }
		]
	}, {
		name: 'Employer Engagements',
		reportType: 2,
		reportName: 'Employer_Engagements',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
			{ name: 'Employer', type: 'select', key: 'employerID', required: false, api: { method: 'getEmployers', text: 'employerName', value: 'employerID' } }
		]
	}, {
		name: 'Employer Engagement Details',
		reportType: 3,
		reportName: 'Employer_Engagement_Details',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
			{ name: 'Employer', type: 'select', key: 'employerID', required: false, api: { method: 'getEmployers', text: 'employerName', value: 'employerID' } }
		]
	}, {
		name: 'Engagements',
		reportType: 4,
		reportName: 'Engagements',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
		]
	}, {
		name: 'Engagement Details',
		reportType: 5,
		reportName: 'Engagement_Details',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
		]
	}
]

export const PresentationDefinition: Report = {
	name: 'Quarterly Reporting Deck',
	reportType: 1,
	reportName: 'Quarterly_Reporting_Deck',
	parameters: [
		{ name: 'Employer', type: 'select', key: 'employerID', required: true, api: { method: 'getEmployers', text: 'employerName', value: 'employerID' } },
		{ name: 'Year', type: 'select', key: 'year', required: true, options: Array.from({ length: 5 }, (_, i) => { const y = new Date().getFullYear() - i; return { label: y.toString(), value: y }; }) },
		{ name: 'Quarter', type: 'select', key: 'quarter', required: true, options: [
			{ label: 'Q1', value: 1 },
			{ label: 'Q2', value: 2 },
			{ label: 'Q3', value: 3 },
			{ label: 'Q4', value: 4 }
		]}
	]
};

export const CommReportDefinitions = [
	{
		name: 'Campaign Summary',
		reportType: 1,
		reportName: 'Campaigns_Summary',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
			{ name: 'Employer', type: 'select', key: 'employerID', required: false, api: { method: 'getEmployers', text: 'employerName', value: 'employerID' } },
			{ name: 'Campaign', type: 'select', key: 'campaignID', required: false, api: { method: 'getCampaigns', text: 'campaignName', value: 'campaignID' } },
		]
	},
	{	
		name: 'Campaign Details',
		reportType: 2,
		reportName: 'Campaign_Details',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
			{ name: 'Employer', type: 'select', key: 'employerID', required: false, api: { method: 'getEmployers', text: 'employerName', value: 'employerID' } },
			{ name: 'Campaign', type: 'select', key: 'campaignID', required: false, api: { method: 'getCampaigns', text: 'campaignName', value: 'campaignID' } },
		]
	},
	{	
		name: 'Campaign Alerts',
		reportType: 3,
		reportName: 'Campaign_Alerts',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
			{ name: 'Employer', type: 'select', key: 'employerID', required: false, api: { method: 'getEmployers', text: 'employerName', value: 'employerID' } },
			{ name: 'Campaign', type: 'select', key: 'campaignID', required: false, api: { method: 'getCampaigns', text: 'campaignName', value: 'campaignID' } },
		]
	},
		{	
		name: 'SMS Opt-In',
		reportType: 4,
		reportName: 'SMS_Opt_In',
		parameters: [
			{ name: 'Start Date', type: 'date', key: 'beginDate', required: true },
			{ name: 'End Date', type: 'date', key: 'endDate', required: false },
			{ name: 'Employer', type: 'select', key: 'employerID', required: false, api: { method: 'getEmployers', text: 'employerName', value: 'employerID' } },
			
		]
	}
]
